/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FieldTable { 
    code?: string;
    label?: string;
    description?: string;
    type?: FieldTable.TypeEnum;
    categoryField?: FieldTable.CategoryFieldEnum;
    pk?: boolean;
    notNull?: boolean;
    autoIncrement?: boolean;
    unique?: boolean;
    tableForFk?: string;
    cardinalie?: string;
    schemaForFk?: string;
    displayableUIPersonal?: boolean;
    anonymizable?: boolean;
    /**
     * Lors de l'import de données, on anonymise la donnée
     */
    anonymization?: boolean;
    labels?: { [key: string]: string; };
    alertWhenChange?: boolean;
    virtualField?: boolean;
    virtualFieldCalculation?: string;
    onDefault?: string;
    onUpdate?: string;
    formattingType?: FieldTable.FormattingTypeEnum;
    defaultLabelFr?: string;
    adminOnly?: boolean;
    fk?: boolean;
}
export namespace FieldTable {
    export type TypeEnum = 'String255' | 'String25' | 'String3' | 'String100' | 'String10' | 'String50' | 'TEXT' | 'BLOB' | 'Int' | 'BigInt' | 'Decimal_5_2' | 'Decimal_8_2' | 'Decimal_11_2' | 'Boolean' | 'DateTime' | 'Date' | 'Time' | 'UUID';
    export const TypeEnum = {
        String255: 'String255' as TypeEnum,
        String25: 'String25' as TypeEnum,
        String3: 'String3' as TypeEnum,
        String100: 'String100' as TypeEnum,
        String10: 'String10' as TypeEnum,
        String50: 'String50' as TypeEnum,
        TEXT: 'TEXT' as TypeEnum,
        BLOB: 'BLOB' as TypeEnum,
        Int: 'Int' as TypeEnum,
        BigInt: 'BigInt' as TypeEnum,
        Decimal52: 'Decimal_5_2' as TypeEnum,
        Decimal82: 'Decimal_8_2' as TypeEnum,
        Decimal112: 'Decimal_11_2' as TypeEnum,
        Boolean: 'Boolean' as TypeEnum,
        DateTime: 'DateTime' as TypeEnum,
        Date: 'Date' as TypeEnum,
        Time: 'Time' as TypeEnum,
        UUID: 'UUID' as TypeEnum
    };
    export type CategoryFieldEnum = 'TECHNICAL' | 'EMAIL' | 'TEXT' | 'NUMBER' | 'DATE' | 'DATE_TIME' | 'TIME' | 'MONTH_NUMBER' | 'DAY_NUMBER' | 'IATA_CITY' | 'IATA_AIRPORT' | 'IATA_COUNTRY' | 'CARRIER' | 'AFFILIATION' | 'LANG' | 'COUNTRY' | 'CIVILITY' | 'ACTIVITY_STATUS' | 'LOYALTY_STATUS' | 'PURCHASE_STATUS' | 'CHANNEL' | 'BOOLEAN' | 'PHONE' | 'MOBILE' | 'PRICE' | 'BOOKING_REFERENCE' | 'PRODUCT_TYPE' | 'TAG' | 'NEWSLETTER';
    export const CategoryFieldEnum = {
        TECHNICAL: 'TECHNICAL' as CategoryFieldEnum,
        EMAIL: 'EMAIL' as CategoryFieldEnum,
        TEXT: 'TEXT' as CategoryFieldEnum,
        NUMBER: 'NUMBER' as CategoryFieldEnum,
        DATE: 'DATE' as CategoryFieldEnum,
        DATETIME: 'DATE_TIME' as CategoryFieldEnum,
        TIME: 'TIME' as CategoryFieldEnum,
        MONTHNUMBER: 'MONTH_NUMBER' as CategoryFieldEnum,
        DAYNUMBER: 'DAY_NUMBER' as CategoryFieldEnum,
        IATACITY: 'IATA_CITY' as CategoryFieldEnum,
        IATAAIRPORT: 'IATA_AIRPORT' as CategoryFieldEnum,
        IATACOUNTRY: 'IATA_COUNTRY' as CategoryFieldEnum,
        CARRIER: 'CARRIER' as CategoryFieldEnum,
        AFFILIATION: 'AFFILIATION' as CategoryFieldEnum,
        LANG: 'LANG' as CategoryFieldEnum,
        COUNTRY: 'COUNTRY' as CategoryFieldEnum,
        CIVILITY: 'CIVILITY' as CategoryFieldEnum,
        ACTIVITYSTATUS: 'ACTIVITY_STATUS' as CategoryFieldEnum,
        LOYALTYSTATUS: 'LOYALTY_STATUS' as CategoryFieldEnum,
        PURCHASESTATUS: 'PURCHASE_STATUS' as CategoryFieldEnum,
        CHANNEL: 'CHANNEL' as CategoryFieldEnum,
        BOOLEAN: 'BOOLEAN' as CategoryFieldEnum,
        PHONE: 'PHONE' as CategoryFieldEnum,
        MOBILE: 'MOBILE' as CategoryFieldEnum,
        PRICE: 'PRICE' as CategoryFieldEnum,
        BOOKINGREFERENCE: 'BOOKING_REFERENCE' as CategoryFieldEnum,
        PRODUCTTYPE: 'PRODUCT_TYPE' as CategoryFieldEnum,
        CONTACTTYPE: 'CONTACT_TYPE' as CategoryFieldEnum,
        TAG: 'TAG' as CategoryFieldEnum,
        NEWSLETTER: 'NEWSLETTER' as CategoryFieldEnum
    };
    export type FormattingTypeEnum = '' | 'lowerCase' | 'upperCase' | 'upperCaseFirst';
    export const FormattingTypeEnum = {
        Empty: '' as FormattingTypeEnum,
        LowerCase: 'lowerCase' as FormattingTypeEnum,
        UpperCase: 'upperCase' as FormattingTypeEnum,
        UpperCaseFirst: 'upperCaseFirst' as FormattingTypeEnum
    };
}